import { sortBy } from 'lodash';

export const sortQuestions = (elements) => sortBy(elements, (element) => element.weight);
